import { Component } from '@angular/core';

@Component({
  selector: 'app-restricted-view',
  standalone: true,
  imports: [],
  templateUrl: './restricted-view.component.html',
  styleUrl: './restricted-view.component.scss'
})
export class RestrictedViewComponent {

}
